/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCode = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.41 6H13.59l-2 2v48l2 2h36.82l2-2V8l-2-2Zm-2 48H15.59V10h32.82v44Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.66 36.29 22.15 32l7.51-4.29v-3.85l-11.72 6.69v2.9l11.72 6.7v-3.86Zm16.41-5.74-11.71-6.69v3.85l7.5 4.29-7.5 4.29v3.86l11.71-6.7v-2.9Z"
}));

export default SvgCode;